import Svg from '@material-symbols/svg-400/outlined/search.svg'
import { type SvgIconProps } from '@mui/material'
import { MaterialSymbol } from './MaterialSymbol'

export function SearchIcon(props: SvgIconProps) {
  return <MaterialSymbol icon={Svg} {...props} />
}
